(function () {
  /* =======================================================
     GLOBAL STATE 
     (Persists across page navigation)
  ======================================================= */
  let selected = new Map();
  let currentTotalCount = 0;
  let currentSubtotal = 0;
  
  // We track the ID of the current grid to know if the user switched products
  let activeGridId = null; 

  /* =======================================================
     HELPER FUNCTIONS
  ======================================================= */
  function getGridElements() {
    const grid = document.querySelector('.CharmGrid');
    const headerTitle = document.querySelector('.SelectedCharmsHeader__Title');
    const subtotalDisplay = document.querySelector('.SelectedCharmsHeader__Subtotal');
    const previewContainer = document.querySelector('.SelectedCharmsPreview');
    return { grid, headerTitle, subtotalDisplay, previewContainer };
  }

  function resetState() {
    selected.clear();
    currentTotalCount = 0;
    currentSubtotal = 0;
  }

  function updateUI() {
    const { grid, headerTitle, subtotalDisplay } = getGridElements();
    if (!grid) return;

    const originalTitle = grid.dataset.originalTitle || 'Optional: Add Charms';
    const currencySymbol = window.ShopifyCharmCurrency || '$';

    // 1. Calculate Totals
    currentTotalCount = 0;
    currentSubtotal = 0;

    selected.forEach((quantity, id) => {
      currentTotalCount += quantity;
      const item = grid.querySelector(`.CharmGrid__Item[data-product-id="${id}"]`);
      // If item is not currently in DOM (rare), skip price calc or use fallback
      const price = item ? parseFloat(item.dataset.price) || 0 : 0;
      currentSubtotal += price * quantity;
    });

    // 2. Update Header Text
    if (headerTitle) {
      // Store original title if not saved yet
      if (!grid.dataset.originalTitle) {
        grid.dataset.originalTitle = headerTitle.textContent;
      }
      headerTitle.textContent = currentTotalCount === 0 
        ? (grid.dataset.originalTitle || 'Optional: Add Charms')
        : `Added Charms (${currentTotalCount})`;
    }

    // 3. Update Subtotal
    if (subtotalDisplay) {
      subtotalDisplay.textContent = `Subtotal ${currencySymbol}${currentSubtotal.toFixed(2)}`;
    }

    // 4. Update Grid Item Visuals (Badges/Borders)
    const allItems = grid.querySelectorAll('.CharmGrid__Item');
    allItems.forEach(item => {
      const id = parseInt(item.dataset.productId, 10);
      const qty = selected.get(id) || 0;
      
      item.classList.toggle('is-selected', qty > 0);
      
      let badge = item.querySelector('.CharmGrid__Badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'CharmGrid__Badge';
        item.appendChild(badge);
      }
      
      if (qty > 0) {
        badge.textContent = qty;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });

    renderPreview();
  }

  function renderPreview() {
    const { previewContainer, grid } = getGridElements();
    if (!previewContainer || !grid) return;

    let html = '';
    selected.forEach((quantity, id) => {
      // Try to find image source from the grid item
      const gridItem = grid.querySelector(`.CharmGrid__Item[data-product-id="${id}"]`);
      const img = gridItem ? gridItem.querySelector('img')?.src : '';

      for (let i = 0; i < quantity; i++) {
        html += `
          <div class="SelectedCharmsPreview__Item">
            <img src="${img}" alt="" class="SelectedCharmsPreview__Image">
            <button type="button" class="SelectedCharmsPreview__RemoveButton" data-remove-id="${id}">&times;</button>
          </div>
        `;
      }
    });
    previewContainer.innerHTML = html;
  }

  /* =======================================================
     CORE LOGIC: EVENT DELEGATION
     (This listens to clicks on the whole document)
  ======================================================= */
  document.addEventListener('click', function(e) {
    
    // --- 1. HANDLE CHARM CLICK ---
    const charmItem = e.target.closest('.CharmGrid__Item');
    if (charmItem) {
      const grid = document.querySelector('.CharmGrid');
      if (!grid) return;

      // Reset if we somehow switched pages but state didn't clear
      // (Optional safety check)
      
      const max = parseInt(grid.dataset.max, 10) || 99;
      const id = parseInt(charmItem.dataset.productId, 10);
      const qty = selected.get(id) || 0;

      if (currentTotalCount >= max && !isNaN(max)) return;

      selected.set(id, qty + 1);
      updateUI();
    }

    // --- 2. HANDLE REMOVE CLICK (In Preview) ---
    const removeBtn = e.target.closest('.SelectedCharmsPreview__RemoveButton');
    if (removeBtn) {
      e.preventDefault();
      const id = parseInt(removeBtn.dataset.removeId, 10);
      if (selected.has(id)) {
        selected.delete(id); // Or decrement if you prefer
        updateUI();
      }
    }
  });

  /* =======================================================
     FORM HIJACKER (Mutation Observer)
     Watches for the form to appear on the page
  ======================================================= */
  function attachFormLogic() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // If we already bound this specific form element, stop.
    if (form.dataset.charmBound === 'true') return;
    form.dataset.charmBound = 'true';

    // Reset state when a new form is detected (implies new product loaded)
    resetState();
    updateUI(); // clear visuals

    const submitBtns = form.querySelectorAll('[type="submit"], [name="add"]');
    
    submitBtns.forEach(btn => {
      // Prevent theme default behavior
      btn.type = 'button'; 
      
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (form.dataset.isSubmitting === 'true') return;
        form.dataset.isSubmitting = 'true';

        const originalText = btn.innerText;
        btn.disabled = true;
        btn.innerText = 'Adding...';

        // Build Payload
        const itemsToAdd = [];
        
        // A. Charms
        if (currentTotalCount > 0) {
          selected.forEach((quantity, id) => {
            itemsToAdd.push({ id: id, quantity: quantity });
          });
        }

        // B. Main Product
        const variantInput = form.querySelector('[name="id"]');
        const qtyInput = form.querySelector('[name="quantity"]');
        
        const properties = {};
        form.querySelectorAll('[name^="properties["]').forEach(input => {
            const match = input.name.match(/properties\[(.*?)\]/);
            if (match && input.value) properties[match[1]] = input.value;
        });

        itemsToAdd.push({
          id: parseInt(variantInput.value, 10),
          quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
          properties: properties
        });

        // Submit
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        })
        .then(res => {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(() => {
          window.location.href = '/cart';
        })
        .catch(err => {
          console.error(err);
          alert('Issue adding to cart.');
          btn.disabled = false;
          btn.innerText = originalText;
          form.dataset.isSubmitting = 'false';
        });
      });
    });
  }

  // Use a MutationObserver to watch for the Form appearing on the page
  // This handles the navigation from Collection -> Product
  const observer = new MutationObserver((mutations) => {
    // Attempt to attach logic whenever DOM changes
    attachFormLogic();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also run once on initial load
  attachFormLogic();

})();